import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import withAuth from '../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import NewsletterManager from '../Components/Newsletter/NewsletterManager';

class NewslettersContainer extends Component {
    constructor(props) {
        super(props);

        let user = JSON.parse(localStorage.getItem('user'));

        this.state = {
            apikey: user.user.apikey,
            username: user.user.email,
            name: user.user.name,
            role: user.user.name
        }
    }

    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body">
                    <Switch>
                        <Route exact path="/newsletters" render={(props) =>
                            <NewsletterManager
                                {...props}
                                history={this.props.history}
                                apikey={this.state.apikey}
                                username={this.state.username}
                                title="Newsletters"
                            />} />
                    </Switch>
                </div>
            </div>
        )
    }
}

export default withAuth(NewslettersContainer);
